import { INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_DELETE, INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_REPLACEMENT, INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_RESET } from '../actions';
const createDefaultEstimatorThumbnailGalleryState = () => ({
    galleryAttachments: []
});
export const photoCaptureIntelligentEstimatorThumbnailGalleryReducer = (state, action) => {
    const currentEstimatorThumbnailGalleryState = state.estimatorThumbnailGalleryTemporaryAttachments || createDefaultEstimatorThumbnailGalleryState();
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_DELETE: {
            const attachments = action.payload.galleryAttachments;
            return Object.assign(Object.assign({}, state), { estimatorThumbnailGalleryTemporaryAttachments: {
                    galleryAttachments: [
                        ...(currentEstimatorThumbnailGalleryState.galleryAttachments || []).filter((existingOperation) => existingOperation.replacedFileId !== attachments.replacedFileId),
                        attachments
                    ]
                } });
        }
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_IMAGE_REPLACEMENT: {
            const attachments = action.payload.galleryAttachments;
            return Object.assign(Object.assign({}, state), { estimatorThumbnailGalleryTemporaryAttachments: {
                    galleryAttachments: [
                        ...(currentEstimatorThumbnailGalleryState.galleryAttachments || []).filter((existingOperation) => existingOperation.replacedFileId !== attachments.replacedFileId),
                        attachments
                    ]
                } });
        }
        case INTELLIGENT_PHOTO_CAPTURE_ESTIMATOR_GALLERY_RESET: {
            return Object.assign(Object.assign({}, state), { estimatorThumbnailGalleryTemporaryAttachments: createDefaultEstimatorThumbnailGalleryState() });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentEstimatorThumbnailGalleryReducer.js.map